import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ service, onRequestService }) => {
  const { name, originalPrice, currentPrice, isPromotion, features, processingTime, badge } = service;

  return (
    <div className="relative overflow-hidden rounded-xl bg-card shadow-lg transition-all duration-300 hover:shadow-xl">
      {badge && (
        <div className="absolute right-4 top-4 rounded-full bg-accent px-3 py-1 text-xs font-semibold text-accent-foreground">
          {badge}
        </div>
      )}
      <div className="p-6">
        <h3 className="mb-2 text-2xl font-bold text-foreground">{name}</h3>
        
        <div className="mb-4 flex items-baseline gap-2">
          {isPromotion && originalPrice && (
            <span className="text-lg text-muted-foreground line-through">
              {originalPrice?.toLocaleString('ko-KR')}원
            </span>
          )}
          <span className="text-3xl font-bold text-primary">
            {currentPrice?.toLocaleString('ko-KR')}원
          </span>
        </div>

        <div className="mb-4 flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Clock" size={16} />
          <span>처리 시간: {processingTime}</span>
        </div>

        <div className="mb-6 space-y-3">
          {features?.map((feature, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-primary/10">
                <Icon name="Check" size={14} color="var(--color-primary)" />
              </div>
              <span className="text-sm text-foreground">{feature}</span>
            </div>
          ))}
        </div>

        <Button
          variant="default"
          fullWidth
          iconName="ArrowRight"
          iconPosition="right"
          onClick={onRequestService}
        >
          서비스 신청하기
        </Button>
      </div>
    </div>
  );
};

export default ServiceCard;